function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Component, register } from 'ovee.js';

var _class = (_dec = register('video-autoplay'), _dec(_class2 = /*#__PURE__*/function (_Component) {
  _inherits(_class2, _Component);

  var _super = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.video = this.$element.querySelector('video');

      if (!this.video) {
        return;
      }

      this.swiperContainer = this.$element.closest('.swiper-container');
      this.inModal = this.$element.closest('[data-modal]');

      if (this.swiperContainer) {
        var isDuplicate = !!this.$element.closest('.swiper-slide-duplicate');

        if (isDuplicate) {
          return;
        }
      }

      this.siblingVideos = false;

      if (this.swiperContainer) {
        var videoUrl = this.video.dataset.src;

        if (videoUrl) {
          this.siblingVideos = this.swiperContainer.querySelectorAll("[data-src=\"".concat(videoUrl, "\"]"));
        }
      }

      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (entry.target.classList.contains('loaded')) {
              _this.play(entry.target);

              entry.target.classList.add('is-in-viewport');
            } else if (entry.target.classList.contains('swiper-lazy-loaded') && _this.inActiveSlide()) {
              _this.playIfActive();
            } else {
              _this.mutationObserver.observe(entry.target, {
                attributes: true,
                attributeFilter: ['data-ll-status']
              });
            }
          } else if (entry.target.classList.contains('loaded') || entry.target.classList.contains('swiper-lazy-loaded')) {
            entry.target.classList.remove('is-in-viewport');

            _this.pause(entry.target);
          }
        });
      }, {
        threshold: 0
      });
      this.observer.observe(this.video);
      this.mutationObserver = new MutationObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target.dataset.llStatus === 'loaded') {
            _this.mutationObserver.disconnect();

            var rect = entry.target.getBoundingClientRect();

            if (rect.bottom >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight)) {
              if (entry.target.classList.contains('swiper-lazy')) {
                _this.playIfActive();
              } else {
                _this.play(entry.target);

                entry.target.classList.add('is-in-viewport');
              }
            }
          }
        });
      });
      this.bind();
    }
  }, {
    key: "bind",
    value: function bind() {
      if (this.swiperContainer) {
        this.$on('slide-change', window, this.playIfActive);
        this.$on('slide-drag', window, this.pauseSiblings);
      }

      this.$on('modal-open', window, this.onModalOpen);
      this.$on('modal-close', window, this.onModalClose);
    }
  }, {
    key: "playIfActive",
    value: function playIfActive() {
      if (this.inActiveSlide() && this.siblingVideos) {
        this.playSiblings();
      } else if (this.siblingVideos) {
        this.pauseSiblings();
      }
    }
  }, {
    key: "playSiblings",
    value: function playSiblings() {
      var _this2 = this;

      this.siblingVideos.forEach(function (video) {
        _this2.play(video);
      });
    }
  }, {
    key: "pauseSiblings",
    value: function pauseSiblings() {
      var _this3 = this;

      this.siblingVideos.forEach(function (video) {
        _this3.pauseAndSync(video);
      });
    }
  }, {
    key: "inActiveSlide",
    value: function inActiveSlide() {
      var isActive = false;

      for (var i = 0; i < this.siblingVideos.length; i++) {
        var video = this.siblingVideos[i];
        var closestActive = video.closest('.swiper-slide-active');
        var closestDuplicateActive = video.closest('.swiper-slide-duplicate-active');

        if (closestActive || closestDuplicateActive) {
          isActive = true;
          break;
        }
      }

      return isActive;
    }
  }, {
    key: "syncTime",
    value: function syncTime() {
      var _this4 = this;

      if (this.siblingVideos) {
        this.siblingVideos.forEach(function (video) {
          video.currentTime = _this4.video.currentTime;
          requestAnimationFrame(function () {
            video.pause();
          });
        });
      }
    }
  }, {
    key: "onModalOpen",
    value: function onModalOpen() {
      if (this.inModal && this.inActiveSlide()) {
        this.playIfActive();
      } else if (this.isPlaying(this.video)) {
        if (this.siblingVideos) {
          this.pauseSiblings();
        } else {
          this.pause(this.video);
        }
      }
    }
  }, {
    key: "onModalClose",
    value: function onModalClose() {
      if (this.inModal && this.inActiveSlide()) {
        this.pauseSiblings();
      } else if (this.isVisible) {
        if (this.siblingVideos) {
          this.playSiblings();
        } else {
          this.play(this.video);
        }
      }
    }
  }, {
    key: "isPlaying",
    value: function isPlaying(video) {
      return video.currentTime > 0 && !video.paused && !video.ended && video.readyState > video.HAVE_CURRENT_DATA;
    }
  }, {
    key: "play",
    value: function play(video) {
      var _this5 = this;

      requestAnimationFrame(function () {
        if (!_this5.isPlaying(video)) {
          video.play();
        }
      });
    }
  }, {
    key: "pause",
    value: function pause(video) {
      var _this6 = this;

      requestAnimationFrame(function () {
        if (_this6.isPlaying(video)) {
          video.pause();
        }
      });
    }
  }, {
    key: "pauseAndSync",
    value: function pauseAndSync(video) {
      var _this7 = this;

      requestAnimationFrame(function () {
        if (_this7.isPlaying(video)) {
          _this7.syncTime();
        }
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.observer.disconnect();
      this.mutationObserver.disconnect();
    }
  }, {
    key: "isVisible",
    get: function get() {
      return this.video.classList.contains('is-in-viewport');
    }
  }]);

  return _class2;
}(Component)) || _class2);

export { _class as default };